"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRedux = require("react-redux");

var _components = require("components");

var _Home = require("../Home/Home");

var _QouteSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/QouteSection");

var _QouteSection2 = _interopRequireDefault(_QouteSection);

var _Feature = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Feature");

var _Feature2 = _interopRequireDefault(_Feature);

var _ImageWithOverlayText = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/ImageWithOverlayText");

var _ImageWithOverlayText2 = _interopRequireDefault(_ImageWithOverlayText);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _VideoLinkSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/VideoLinkSection");

var _VideoLinkSection2 = _interopRequireDefault(_VideoLinkSection);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _utils = require("utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonsGroup = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(3)
});

var button = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(1),
  width: (0, _css.unitRem)(9.5),

  ":first-child": {
    marginLeft: 0
  }
});

var Bridge = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn,
    user: state.user
  };
}), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(Bridge, _React$Component);

  function Bridge(props) {
    (0, _classCallCheck3.default)(this, Bridge);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Bridge.__proto__ || (0, _getPrototypeOf2.default)(Bridge)).call(this, props));

    _this.state = {
      platform: "Windows"
    };
    return _this;
  }

  (0, _createClass3.default)(Bridge, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: "render",
    value: function render() {
      var _React$createElement2;

      var platform = this.state.platform;
      var user = this.props.user;


      var bridgeDownloadUrl = _utils.bridgeBuilds[platform.toLowerCase()];
      var mailTo = encodeURI("mailto:?subject=Quixel Bridge Download Link&body=Note to self: Remember to download Quixel Bridge the next time I am on my desktop machine.\n" + "Here are the download links —\n\n" + "Windows: " + _utils.bridgeBuilds.windows + "\n\n" + "Mac: " + _utils.bridgeBuilds.mac + "\n\n" + "Linux: " + _utils.bridgeBuilds.linux + "\n\n");

      if (__CLIENT__ && (0, _utils.detectMobileAndTablet)()) {
        bridgeDownloadUrl = mailTo;
      }

      var downlaodText = this.state.platform === "Windows" ? "WINDOWS" : "MAC";
      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Bridge - Manage 3D content and export with one click",
          documentImage: cf_utils.cf_thumbs("page-thumb-bridge.jpg"),
          documentDescription: "Quixel Bridge provides 3D asset management and saves time with one click integrations to your preferred tools, for free."
        },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_components.Hero, (0, _defineProperty3.default)({
            bg: cf_utils.cf_qx_page("bridge", "bridge-hero.jpg"),
            superIconUrls: [cf_utils.cf_icons("bridge_icon_2048.png")],
            primaryLabel: "",
            primaryTo: "",
            title: "Bridge",
            opacity: 0.25,
            subTitle: "YOUR GATEWAY TO MEGASCANS AND METAHUMANS",
            secondaryLabel: "Download Bridge",
            secondaryTo: bridgeDownloadUrl
            // toolTip={this.props.loggedIn ? null : toolTip}
            , linkIcon: this.props.loggedIn ? "rightSide" : "",
            link: {
              label: "Discover Bridge inside Unreal Engine",
              href: "https://youtu.be/ParMLadMTaQ",
              target: "_blank"
            }
          }, "linkIcon", "rightSide")),
          _react2.default.createElement(_components.DescriptionWith3Columns, {
            title: "What is Bridge",
            headingBeforeBreak: "Discover a World of Content",
            headingAfterBreak: "with Bridge",
            columns: [{
              img: cf_utils.cf_icons("instant_access.svg"),
              isIcon: false,
              title: "Much to Explore",
              desc: "Browse the libraries of Megascans and MetaHumans content in a quick and artist-friendly way through Bridge."
            }, {
              img: cf_utils.cf_icons("powerful_management.svg"),
              isIcon: false,
              title: "Also Inside Unreal Engine 5",
              desc: "Fire up an all-new Bridge tab right inside of <a style='text-decoration:none;color:#2B98F0;font-size:inherit;letter-spacing:inherit;' target='_blank'href='https://www.unrealengine.com'>Unreal Engine 5</a> and drop optimized content directly into your project."
            }, {
              img: cf_utils.cf_icons("deep_integartions.svg"),
              isIcon: false,
              title: "Work with your tools",
              desc: "Seamlessly export to your favorite 3D application or game engine with one click. Save time and have fun creating."
            }]
          }),
          _react2.default.createElement(_VideoLinkSection2.default, {
            typeLable: "Meet Bridge for Unreal Engine 5",
            YTid: "ParMLadMTaQ",
            bg: cf_utils.cf_qx_page("megascans", "bridge_UE5.jpeg")
          }),
          _react2.default.createElement(_components.Hero, {
            bg: cf_utils.cf_qx_page("home", "unrealengine-cta-bg.jpeg"),
            title: "Bridge is now available directly<br>inside Unreal Engine 5",
            subTitle: "Simply open the Bridge tab and drag and drop optimized Megascans content<br>directly into your project with no need to download or export assets.",
            secondaryLabel: "Get Unlimited Access",
            secondaryTo: "https://www.unrealengine.com",
            primaryLabel: "",
            primaryTo: "",
            opacity: 0.25,
            superIconUrls: [cf_utils.cf_icons("UE_Logo_icon-only_white_@2x.png")],
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("home", "bridge_by_quixel_herovideo_FALLBACK.jpg"),
              loop: "true",
              src: cf_utils.cf_qx_page("home", "bridge_by_quixel_herovideo_compressed.mp4")
            }
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "Bridge",
            img: cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-1.jpg"),
            images: [cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-1.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-2.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-3.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-4.jpg"), cf_utils.cf_qx_page("megascans", "megascans-every-type-of-scan-imaginable-5.jpg")],
            title: "your gateway to Megascans",
            newHome: true,
            desc: "Thousands of 3D assets, tileable surfaces, imperfections, vegetation, atlases, and decals from around the world at your finger tips. Work on photoreal or highly stylized projects with the highest quality 3D content in the industry. New Megascans content is captured and added to the library every single day.",
            link: [{
              to: "/megascans/home",
              label: "Browse Megascans"
              // onClick:()=>(__CLIENT__ ? window.location=window.location.protocol+'//'+window.location.hostname+'/megascans/library/':'')
            }]
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "Bridge",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "bridge-metahuman-A.jpg"),
            images: [cf_utils.cf_qx_page("bridge", "bridge-metahuman-A.jpg"), cf_utils.cf_qx_page("bridge", "bridge-metahuman-B.jpg"), cf_utils.cf_qx_page("bridge", "bridge-metahuman-C.jpg"), cf_utils.cf_qx_page("bridge", "bridge-metahuman-D.jpg"), cf_utils.cf_qx_page("bridge", "bridge-metahuman-E.jpg"), cf_utils.cf_qx_page("bridge", "bridge-metahuman-F.jpg")],
            title: "Metahumans have a home in Bridge",
            desc: "Through Bridge, you can access your bespoke MetaHumans created in MetaHuman Creator, as well as over 50 premade MetaHumans. With both UAssets and source assets available, you can use Bridge to download and export your digital humans for direct use in Unreal Engine or further editing in Maya.",
            link: [{
              href: "https://www.unrealengine.com/en-US/metahuman-creator",
              label: "Learn more about MetaHumans",
              newWindow: true
            }],
            flip: true
          }),
          _react2.default.createElement(
            _Slider2.default,
            { delay: 7 },
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("journeyman-quote-2.jpg"),
              icon: cf_utils.cf_testimonials("icon/gnomon.png"),
              title: "\u201CThanks to Bridge, the Megascans library is now easier to use than ever, becoming an almost one-click solution to incorporate into almost any tool or workflow.\u201D",
              subTitle: "\u2014 Alex Alvarez, Founder/President, Gnomon",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("ford-gt-campaign-quote-2.jpg"),
              icon: cf_utils.cf_testimonials("icon/burrows.png"),
              title: "\u201CBridge is great for organizing scans in a visually appealing way. Some things we would never realize we needed until we see them in Bridge and this really inspires our creativity.\u201D",
              subTitle: "\u2014 Ben Walker, CGI Head of Real-Time, Burrows",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("dice-test.jpg"),
              icon: cf_utils.cf_testimonials("icon/dice.png"),
              title: "\u201CBridge is very efficient to work with. Having everything so accessible and structured makes it easy to find, manage and use content.\u201D",
              subTitle: "\u2014 Pontus Ryman, Senior Environment Artist, EA DICE",
              hr: true
            }),
            _react2.default.createElement(_QouteSection2.default, {
              bg: cf_utils.cf_testimonials("angkor-wat.jpg"),
              title: "\u201CIt\u2019s a really simple and straight-forward process \u2014 it\u2019s literally just one click to have a ready-to-use asset inside Maya, or in your preferred software.\u201D",
              subTitle: "\u2014 Rafael Chies, Lookdev, Environment/Prop Artist",
              subHeading: "POWER USERS",
              hr: true
            })
          ),
          _react2.default.createElement(_Feature2.default, {
            featureType: "BRIDGE",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "connect_with_any_software_UE5.jpeg"),
            title: "Connect with any software",
            desc: "Send assets straight to Unreal Engine, 3ds Max, Houdini, Unity, Blender, Cinema 4D, Clarisse, Maya, and more, with automatic mesh and shader setups for all major renderers. Forget trying to correctly set up shaders or spending time hooking up map slots\u2014just jump right into your project.",
            link: [{
              href: "https://www.youtube.com/quixeltools",
              label: "Watch tutorials",
              newWindow: true
            }],
            flip: true
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "BRIDGE",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "choose_the_right_format_for_you_UE5.jpeg"),
            title: "Choose the right format for you",
            desc: "Work in the format you want. Bridge offers a variety of formats: from the standard FBX and OBJ to up-and-coming standards such as USD and MDL. Whatever you choose, we\u2019ve got you covered.",
            link: [{
              href: bridgeDownloadUrl,
              label: __CLIENT__ && (0, _utils.detectMobileAndTablet)() ? "Download" : ("Download for " + this.state.platform).toUpperCase(),
              newWindow: true
            }]
          }),
          _react2.default.createElement(_Feature2.default, (_React$createElement2 = {
            featureType: "BRIDGE",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "bridge-make-bridge-your-own.jpg"),
            title: "Make Bridge your own",
            desc: "Create channel-packing presets, use custom naming conventions, modify export scripts or easily create your own for any 3D software, engine or renderer\u2014even your own. Unlock full API access to Megascans for all your custom pipeline needs, and stay in control."
          }, (0, _defineProperty3.default)(_React$createElement2, "img", cf_utils.cf_qx_page("bridge", "bridge-make-bridge-your-own.jpg")), (0, _defineProperty3.default)(_React$createElement2, "flip", true), _React$createElement2)),
          _react2.default.createElement(_Feature2.default, {
            featureType: "BRIDGE",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "bridge-theres-more-to-the-magic.jpg"),
            title: "There\u2019s more to the magic",
            desc: "In addition to the many amazing software integrations, you also have access to a wide range of world-class creative tools for UE4 and Houdini, including powerful scattering, quick multi-material blending,  advanced physical simulation, and much more.",
            artist: "ROCOCOON"
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "BRIDGE",
            newHome: true,
            img: cf_utils.cf_qx_page("bridge", "bridge-avaliable-on-pc-mac-and-linux.jpg"),
            title: "Available on PC, Linux and Mac",
            desc: "Quixel Bridge is available for Windows, Linux and macOS.",
            link: [{
              href: bridgeDownloadUrl,
              label: __CLIENT__ && (0, _utils.detectMobileAndTablet)() ? "Download" : ("Download for " + this.state.platform).toUpperCase(),
              newWindow: true
            }],
            artist: "Sergey Ferley",
            flip: true
          }),
          _react2.default.createElement(_components.UnrealUnlimitedBanner, {
            backgroundVideo: {
              poster: cf_utils.cf_qx_page("home", "unlimitedaccess-loop-FALLBACK.jpg"),
              loop: "true",
              src: cf_utils.cf_qx_page("home", "unlimitedaccess-loop-compressed.mp4")
            },
            title: "Unlimited Megascans access<br>for use with Unreal Engine",
            subTitle: "If you have a Content License, simply sign in with your Epic Games<br>account to get unlimited access to the Megascans library through Bridge.*",
            message: "*This Megascans access is licensed for use with Unreal Engine-based products only and treats Megascans<br>assets as Epic Games Content under the Content License Agreement.<br><br>",
            secondaryLabel: "begin for free",
            user: user,
            link: {
              label: "View other licences",
              to: "/pricing"
            }
          })
        )
      );
    }
  }]);
  return Bridge;
}(_react2.default.Component)) || _class);
exports.default = Bridge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Apps/Bridge.jsx
// module id = 2968
// module chunks = 0